import {skipWaiting as workbox_core_skipWaiting} from 'C:/CodigoFuentes/LA-VETE/INTERFACE/LDVET/LDVET/LDVET/ClientApp/node_modules/workbox-core/skipWaiting.mjs';
import {clientsClaim as workbox_core_clientsClaim} from 'C:/CodigoFuentes/LA-VETE/INTERFACE/LDVET/LDVET/LDVET/ClientApp/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'C:/CodigoFuentes/LA-VETE/INTERFACE/LDVET/LDVET/LDVET/ClientApp/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








workbox_core_skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "./ClientApp/public/dist/0.3c0953cba7567a4d24d3.js",
    "revision": "63abdde8e734924d7db73f11bfa55401"
  },
  {
    "url": "./ClientApp/public/dist/0.3c0953cba7567a4d24d3.js.map",
    "revision": "93a90cefab36b531252b0b7975bec0bc"
  },
  {
    "url": "./ClientApp/public/dist/1.9a0bfe5f20fda57095bb.js",
    "revision": "0146047a5ba5e7007f19bd6646f6d557"
  },
  {
    "url": "./ClientApp/public/dist/1.9a0bfe5f20fda57095bb.js.map",
    "revision": "88b7130a077b280138140c903942de76"
  },
  {
    "url": "./ClientApp/public/dist/10.8ff0fadf4b89153604cf.js",
    "revision": "01f32ea70d7cb81cdbfb165ba602330c"
  },
  {
    "url": "./ClientApp/public/dist/10.8ff0fadf4b89153604cf.js.map",
    "revision": "5bc0d4758074645013956e9a225671a1"
  },
  {
    "url": "./ClientApp/public/dist/11.c618fcf82f3c6f918050.js",
    "revision": "657f3438a38ef503d6b5c0cb3d0552db"
  },
  {
    "url": "./ClientApp/public/dist/11.c618fcf82f3c6f918050.js.map",
    "revision": "b979d16255d3d5ff7424f62061a7c511"
  },
  {
    "url": "./ClientApp/public/dist/12.f85e772ca1dd7b3bdce6.js",
    "revision": "6d92f865e618ff5d16930f43f75defea"
  },
  {
    "url": "./ClientApp/public/dist/12.f85e772ca1dd7b3bdce6.js.map",
    "revision": "903e6d6f6b60b1425593cf9064a8acbe"
  },
  {
    "url": "./ClientApp/public/dist/13.a8af1555799baf9b7e07.js",
    "revision": "40296b8e352a4a173353a0aa9271b834"
  },
  {
    "url": "./ClientApp/public/dist/13.a8af1555799baf9b7e07.js.map",
    "revision": "fe3b5af09f29595f05114b448f4fb66e"
  },
  {
    "url": "./ClientApp/public/dist/14.0c2b3ccd6a5c55fe763e.js",
    "revision": "fd8d5367f865a447923b649aacbeffe9"
  },
  {
    "url": "./ClientApp/public/dist/14.0c2b3ccd6a5c55fe763e.js.map",
    "revision": "c283ec7b2c5df9d6fcc8a1b634e45521"
  },
  {
    "url": "./ClientApp/public/dist/15.e3e3cdc5de1e09270530.js",
    "revision": "e06dbf856dd7c6c142f3b9d8fa8a4d38"
  },
  {
    "url": "./ClientApp/public/dist/15.e3e3cdc5de1e09270530.js.map",
    "revision": "fa73fb29077da148f20004022efd5499"
  },
  {
    "url": "./ClientApp/public/dist/16.6e1cc34c20c6522812e5.js",
    "revision": "3a1c50cb697258db137e68cf8ba7fc7f"
  },
  {
    "url": "./ClientApp/public/dist/16.6e1cc34c20c6522812e5.js.map",
    "revision": "537baf400ad02a474ecb7dccc9466ac9"
  },
  {
    "url": "./ClientApp/public/dist/17.accf5793061d124777b6.js",
    "revision": "af19dbdb552e2eac84b223806358770d"
  },
  {
    "url": "./ClientApp/public/dist/17.accf5793061d124777b6.js.map",
    "revision": "8742e746241961e5218bbb789c0b801b"
  },
  {
    "url": "./ClientApp/public/dist/18.664577a66cda40968ffe.js",
    "revision": "cd9e9c6e2796169c52ea80d7a70b68fc"
  },
  {
    "url": "./ClientApp/public/dist/18.664577a66cda40968ffe.js.map",
    "revision": "b84277e329e6134de42331ed98e93c47"
  },
  {
    "url": "./ClientApp/public/dist/19.f1f5aca0efd789fca66d.js",
    "revision": "ac1835d9722c8f4952698a72ac2703d4"
  },
  {
    "url": "./ClientApp/public/dist/19.f1f5aca0efd789fca66d.js.map",
    "revision": "497609b4dabc470f4ab266e1754e2cf0"
  },
  {
    "url": "./ClientApp/public/dist/2.df686ad648872a9631d4.js",
    "revision": "902d78b9851bf5cca19a3b0360b99b45"
  },
  {
    "url": "./ClientApp/public/dist/2.df686ad648872a9631d4.js.map",
    "revision": "30c20a7b0940f596bbe0a1f4647d3720"
  },
  {
    "url": "./ClientApp/public/dist/20.48133169adc4feefe7ca.js",
    "revision": "5fc16c473b0fd0fb27fd0237d91c4a6e"
  },
  {
    "url": "./ClientApp/public/dist/20.48133169adc4feefe7ca.js.map",
    "revision": "b41eeb8de734d4a8fdd6d287870c9037"
  },
  {
    "url": "./ClientApp/public/dist/21.be484ed6b12d85f56111.js",
    "revision": "994edb91e6a5748585f6d8efd881f40c"
  },
  {
    "url": "./ClientApp/public/dist/21.be484ed6b12d85f56111.js.map",
    "revision": "2fff281b1256da8357fed359d16cfac9"
  },
  {
    "url": "./ClientApp/public/dist/22.99d1040a14bd5a54e6ff.js",
    "revision": "3e43fa468c82189f510f5be4a755ff5e"
  },
  {
    "url": "./ClientApp/public/dist/22.99d1040a14bd5a54e6ff.js.map",
    "revision": "69f073b366be509ea3ffc8d0f01ad9c0"
  },
  {
    "url": "./ClientApp/public/dist/23.0b6602e5afe4c931a021.js",
    "revision": "b9a082f5effa9e3b3f5c3714e318a3cb"
  },
  {
    "url": "./ClientApp/public/dist/23.0b6602e5afe4c931a021.js.map",
    "revision": "01bab05568c548fbd825ef544cfc1070"
  },
  {
    "url": "./ClientApp/public/dist/24.33315cd29e14dfe92bc3.js",
    "revision": "c231694d94fe7e191659e68c6be9c3e2"
  },
  {
    "url": "./ClientApp/public/dist/24.33315cd29e14dfe92bc3.js.map",
    "revision": "9bddd5868e680e2dbb3f964b72fda8c2"
  },
  {
    "url": "./ClientApp/public/dist/25.d60c65788d8879dbecbe.js",
    "revision": "489de4802c40a29991c975347071c6cb"
  },
  {
    "url": "./ClientApp/public/dist/25.d60c65788d8879dbecbe.js.map",
    "revision": "2bd0f5618bcc0c2982ced4f1be8c616e"
  },
  {
    "url": "./ClientApp/public/dist/26.7bf361b634be1106d629.js",
    "revision": "72e1c8e02b5e474686ac4ad6cf1a2adb"
  },
  {
    "url": "./ClientApp/public/dist/26.7bf361b634be1106d629.js.map",
    "revision": "1e147bb2e7f0d3206939b6dd368cf576"
  },
  {
    "url": "./ClientApp/public/dist/3.833f45a895116c2762c8.js",
    "revision": "83f1d5b75d0cb732efb896dd8d40493f"
  },
  {
    "url": "./ClientApp/public/dist/3.833f45a895116c2762c8.js.map",
    "revision": "815b27fdcf3f7018314cf91e4b8592e4"
  },
  {
    "url": "./ClientApp/public/dist/4.6f8a746339ab791a13b3.js",
    "revision": "80658bdc1de633970cc8a8f47fd11126"
  },
  {
    "url": "./ClientApp/public/dist/4.6f8a746339ab791a13b3.js.map",
    "revision": "4ed63988364d14fea7523d97cde375ca"
  },
  {
    "url": "./ClientApp/public/dist/5.1b8cf624e783ab512c74.js",
    "revision": "ff6a509538a52a7c3ae6112296dac553"
  },
  {
    "url": "./ClientApp/public/dist/5.1b8cf624e783ab512c74.js.map",
    "revision": "d9060351d795f1ee8419ab76f8cd8ae4"
  },
  {
    "url": "./ClientApp/public/dist/8.2add59ad42985322a35c.js",
    "revision": "fa657da5159f552ee5f9aeb7b8b85946"
  },
  {
    "url": "./ClientApp/public/dist/8.2add59ad42985322a35c.js.map",
    "revision": "6e2a9a0434d3bf5a4032d2458b537dbb"
  },
  {
    "url": "./ClientApp/public/dist/9.92ba967f593ebae56e9d.js",
    "revision": "fe61e0a59412e6d4c3656cda009182fa"
  },
  {
    "url": "./ClientApp/public/dist/9.92ba967f593ebae56e9d.js.map",
    "revision": "c96279f29e0f3faec53f15b84944b6e8"
  },
  {
    "url": "./ClientApp/public/dist/app.a4c95f796b18ba6235e0.js",
    "revision": "73a97a4435c64e577a5e175a0ae3747e"
  },
  {
    "url": "./ClientApp/public/dist/app.a4c95f796b18ba6235e0.js.map",
    "revision": "4e20f7f64781da28a352ed2ca4cd8581"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.43509eb22115c923f91c.js",
    "revision": "ad544e5062a94011c936dc1916a6ee6e"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.43509eb22115c923f91c.js.map",
    "revision": "121aae7a8c27c486bb999e11ba90b44b"
  }
], {});








